<template>
  <div class="">
    <modal :show.sync="modals.supportdoc" class="modal-eprf" centered>
      <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
        header="DOCUMENTS" header-bg-variant="primary" header-text-variant="white">
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">DOCUMENTS</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.supportdoc = false"></i>
              </base-button>
            </div>
          </div>
        </template>

        <div :style="{ height: otheropen ? '400px' : '180px', overflow: 'auto', 'overflow-x': 'hidden' }">

          <div class="col-lg-12">
            <el-table :data="allfilename" :header-cell-style="{
      background: '#358DCC',
      border: 'transparent',
      'font-size': '14px',
      'font-weight': '400',
      color: '#FFFFFF',
    }">
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openother()" style="cursor: pointer;"><span>{{ scope.column.label }}</span></div>
                </template>
                <div v-if="otheropen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="Job Supporting Documents" :min-width="350" prop="filename" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openother()" style="cursor: pointer;"><span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="otheropen == true" slot-scope="scope" style="height: 20px" align="left">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="▼" width="100" align="center">
                <div v-if="otheropen == true" slot-scope="scope">
                  <a :href="scope.row.fileurl" target="_blank">
                    <i class="tim-icons icon-cloud-download-93 download-icon"></i>

                  </a>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div :style="{ height: quoopen ? '400px' : '180px', overflow: 'auto', 'overflow-x': 'hidden' }">

          <div class="col-lg-12">
            <el-table :data="allquodocname" :header-cell-style="{
      background: '#358DCC',
      border: 'transparent',
      'font-size': '14px',
      'font-weight': '400',
      color: '#FFFFFF',
    }">
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openquo()" style="cursor: pointer;"><span>{{ scope.column.label }}</span></div>
                </template>
                <div v-if="quoopen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="Quotation Supporting Documents" :min-width="350" prop="filename" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openquo()" style="cursor: pointer;"><span>{{ scope.column.label }}</span></div>
                </template>
                <div v-if="quoopen == true" slot-scope="scope" style="height: 20px" align="left">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="▼" width="100" align="center">
                <div v-if="quoopen == true" slot-scope="scope">
                  <a :href="scope.row.fileurl" target="_blank">
                    <i class="tim-icons icon-cloud-download-93 download-icon"></i>

                  </a>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </b-card>
    </modal>
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              JOB DETAILS
            </p>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <p class="new-title">Job Reference No.</p>
              <p class="subtitle">{{ jobno }}</p>

              <p class="new-title">Service location</p>
              <p class="subtitle">{{ servicelocation }}</p>

              <p class="new-title">Company Name</p>
              <p class="subtitle">{{ companyName }}</p>

              <p class="new-title">Company Address</p>
              <p class="subtitle">{{ companyAddress }}</p>

              <p class="new-title">Phone No. / Fax No.</p>
              <p class="subtitle">{{ phoneNoFaxNo }}</p>

              <p class="new-title">PIC Full Name</p>
              <p class="subtitle">{{ picFullName }}</p>

              <p class="new-title">PIC Phone No. / Fax No.</p>
              <p class="subtitle">{{ picPhoneNoFaxNo }}</p>

              <p class="new-title">PIC Email</p>
              <p class="subtitle">{{ picEmail }}</p>
            </div>
          </card>
        </div>
        <div class="col-lg-8 d-flex">
          <card class="card-eprf">
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  WASTE DETAILS
                </p>
              </div>
              <div class="col-lg-3 text-right" v-if="positionid != 4">
                <div class="row">
                  <div class="col-lg">Marketing Channel:</div>
                </div>
                <div class="row">
                  <!-- @change="sendMarketingChannel()" -->
                  <div class="col-lg">
                    <el-select v-model="marketingchannel" filterable>
                      <!--  -->
                      <el-option class="select-primary" v-for="(item, index) in marketingchannels" :key="index"
                        :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="row" style="height: 520px; overflow: auto; overflow-x: hidden">
              <div class="col-lg">
                <!--   :cell-class-name="evenclass" -->
                <el-table :data="wastedetails" :header-cell-style="{
      background: '#358DCC',
      border: 'transparent',
      'font-size': '14px',
      'font-weight': '400',
      color: '#FFFFFF',
    }" :cell-style="{ fontColor: '#707070' }" :row-style="tableRowClassName">
                  <el-table-column label="NO." width="50" align="center">
                    <div slot-scope="scope">
                      <p style="color: #707070">{{ scope.$index + 1 }}</p>
                    </div>
                  </el-table-column>

                  <el-table-column align="center" label="WASTE TYPE" prop="wastetype" :min-width="200">
                    <div slot-scope="{ row }">
                      <div align="left">
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">
                              Waste Type: {{ row.wastetype }}
                            </p>
                            <p style="color: #A5A5A5">
                              Packaging: {{ row.packagingtype }}
                            </p>
                            <p style="color: #A5A5A5">
                              Waste Origin: {{ row.wasteorigin }}
                            </p>
                          </div>
                        </div>
                        <div class="row" style="
                            border: 1px solid #e6e6e6;
                            width: 100%;
                            margin-left: 3px;
                          " v-for="(item, index) in row.image" :key="index">
                          <div class="col-lg" style="padding: 5px">
                            <img :src="item.url" width="70" height="40" @click="openimage(item.url)" />
                          </div>
                          <div class="col-lg">
                            <p style="
                                color: #A5A5A5;
                                white-space: nowrap;
                                width: 70px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                font-size: 10px;
                                line-height: 1em;
                              ">
                              {{ item.meta.filename }}
                            </p>
                            <p style="
                                color: grey;
                                line-height: 0.5;
                                font-size: 10px;
                              ">
                              {{ item.meta.filesize }}
                            </p>
                          </div>
                          <div class="col-lg-3 text-center" style="border-left: 1px solid #e6e6e6">
                            <base-button class="btn-icon btn-link">
                              <a :href="item.url"><img src="@/assets/img/eprf-download-grey.png"
                                  width="20" /></a></base-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-table-column>
                  <el-table-column :min-width="150" align="center" label="WASTE COMPONENT" prop="wastecomponent">
                    <div slot-scope="{ row }">
                      <p style="color: #A5A5A5" v-for="(item, index) in row.wastecomponent" :key="index">
                        {{ index + 1 }}. {{ item.component_name == null || item.component_name == '' ? 'N/A' : item.component_name }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column label="EST. QTY." align="center" prop="estqty" :min-width="150">
                    <div slot-scope="{ row }">
                      <p style="color: #A5A5A5">
                        {{ row.estqty }} {{ row.estqtyunit }}
                      </p>
                      <p style="color: #A5A5A5">
                        {{ row.packagingqty }} {{ row.packagingqtyunit }}
                      </p>
                    </div>
                  </el-table-column>

                  <el-table-column :min-width="200" label="REMARKS" align="center" prop="remarks"></el-table-column>
                </el-table>
              </div>
            </div>
          </card>
        </div>
        <!-- <div class="col-lg-4">
          <card
            style="
              box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              CUSTOMER DETAILS
            </p>

            <p class="new-title">Company Name</p>
            <p class="subtitle">Ombak Biru Holdings</p>

            <p class="new-title" style="padding-top: 50px">Company Address</p>
            <p class="subtitle">
              202, Jalan Port Klang Pelabuhan, 42005 Selangor, Malaysia
            </p>

            <p class="new-title" style="padding-top: 50px">
              Phone No. / Fax No.
            </p>
            <p class="subtitle">+603 4562 7890</p>
          </card>
        </div>
        <div class="col-lg-4">
          <card
            style="
              box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              PIC DETAILS
            </p>

            <p class="new-title">Full Name</p>
            <p class="subtitle">Amirah binti Azman</p>

            <p class="new-title" style="padding-top: 50px">
              Phone No. / Fax No.
            </p>
            <p class="subtitle">+019 562 7890</p>

            <p class="new-title" style="padding-top: 50px">Email</p>
            <p class="subtitle">amirah@ombakb.com.my</p>
          </card>
        </div>
      
        <div class="col-lg-4">
          <card
            style="
              box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              SHIP DETAILS
            </p>

            <div
              style="margin-left: -30px"
              class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
            >
              <p class="new-title">Ship Name</p>
              <p class="subtitle">Eagle 01</p>

              <p class="new-title">IMO No.</p>
              <p class="subtitle">8814275</p>

              <p class="new-title">Ship Type</p>
              <p class="subtitle">Oil tanker</p>
              <p class="new-title">Gross Tonnage</p>
              <p class="subtitle">220,000</p>

              <p class="new-title">Deadweight Tonnage (kg)</p>
              <p class="subtitle">+019 562 7890</p>

              <p class="new-title">Owner / Operator Name</p>
              <p class="subtitle">Rizal bin Abdullah</p>

              <p class="new-title">Call Sign</p>
              <p class="subtitle">Starlight</p>

              <p class="new-title">Flag State</p>
              <p class="subtitle">Malaysia</p>

              <p class="new-title">Sustainable Certificates</p>
              <p class="subtitle">1 - ISO 14001.pdf</p>
              <p class="subtitle">2 - EU Ecolabel.pdf</p>
            </div>
          </card>
        </div>
        <div class="col-lg-4">
          <card
            style="
              box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              WASTE TO BE COLLECTED
            </p>
            <p class="new-title">Waste Type</p>
            <p class="subtitle">Annex I - Oily bilge water</p>

            <p class="new-title" style="padding-top: 50px">Waste Quantity</p>
            <p class="subtitle">300 MT</p>

            <p class="new-title" style="padding-top: 50px">
              Max Dedicated Storage Capacity
            </p>
            <p class="subtitle">500 MT</p>

            <p class="new-title" style="padding-top: 50px">
              Amount of Waste Retained Onboard
            </p>
            <p class="subtitle">50 MT</p>
          </card>
        </div> -->
      </div>
      <div class="row">
        <div class="col-lg-4"></div>
        <div class="col-lg-3 text-left">
          <base-button @click="modals.supportdoc = true" type="primary">View Documents</base-button>
        </div>
        <div class="col-lg text-right">
          <base-button v-if="positionid != 4 && step == 1" wide type="cancel" @click="modals.disputereason = true" class="btn-dispute">
            DISPUTE
          </base-button>
          <base-button v-if="positionid != 4 && step == 1" type="primary" wide @click="accept()" class="btn-next">
            ACCEPT
          </base-button>
          <base-button v-if="step != 1" type="primary" wide @click="nextTab" class="btn-next">
            NEXT
          </base-button>
        </div>
      </div>
    </div>

    <StatusModal :show.sync="modals.successModal" :message="modal.jobaccept" :title="modal.successTitle" />
    <StatusModal :show.sync="modals.removeModal" :message="modal.remove" :title="modal.removeTitle" />
    <StatusModal :show.sync="modals.successUpload" :message="modal.success" :title="modal.successTitle" />

    <modal :show.sync="modals.disputereason" class="modal-eprf" centered>
      <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
        header="REASON FOR DISPUTE" header-bg-variant="primary" header-text-variant="white">
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">REASON FOR DISPUTE</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.disputereason = false"></i>
              </base-button>
            </div>
          </div>
        </template>

        <div class="row">
          <div class="col-lg-12">
            <textarea style="border: 1px solid #aaa; background-color: white;"  type="textarea" placeholder="Reason for rejection..." v-model="reason"
              :class="{ textarea: true }"></textarea>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-1">
            <div class="fileinput">
              <label style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                " for="file-upload" type="primary" class="btn">
                Upload
              </label>

              <div class="d-flex justify-content-center spinner" v-if="this.uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="file-upload" ref="file" type="file" name="..." class="valid"
                :multiple="true" aria-invalid="false" style="display: none" v-on:change="onFileChange" />
            </div>
          </div>

          <!-- <div class="col-lg"></div> -->
          <div class="col-lg text-left">
            <div class="row">
              <p class="" style="margin-left: 80px; color: #A5A5A5">
                {{
      quotitle.length > 30
        ? quotitle.slice(0, 30) + "..."
        : quotitle
    }}
              </p>
              <i v-if="quotitle.length > 0" style="
                  color: #ff0000;
                  font-weight: 900;
                  font-size: 20px;
                  margin-left: 10px;
                  margin-top: 20px;
                " class="tim-icons icon-simple-remove" v-on:click="deletedisputedoc()"></i>
            </div>
          </div>
          <div class="col-lg-4 text-right">
            <base-button type="primary" v-on:click="dispute()">Submit</base-button>
          </div>
        </div>
      </b-card>
    </modal>
    <modal :show.sync="modals.image" class="modal-eprf">
      <!-- <div class="row" style="position: fixed; right: 0; top: 0;">
        <div class="col-lg-12 text-right" style="margin-bottom: 50px">
          <base-button class="btn-link" type="primary" v-on:click="modals.image = false"
            ><i class="tim-icons icon-simple-remove" style="font-size:50px"></i></base-button
          >
        </div>
      </div> -->
      <div class="row">
        <div class="col-lg">
          <img :src="image" />
        </div>
      </div>
    </modal>
    <!-- <div class="col-lg-12">
      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button type="danger" v-on:click="getBack()">Cancel</base-button
          >&nbsp;
          <base-button type="primary" v-on:click="handleDone()">Done</base-button>
        </div>
      </div>
      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <p

            style="text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </p>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Option,
  Select,
  DatePicker,
  TimePicker,
  TimeSelect,
} from "element-ui";
import moment, { utc } from "moment";
import swal from "sweetalert2";
import { ImageUpload, Modal } from "src/components";
import { colors } from "../../../../../components/colors.js";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";
import { Circle8 } from "vue-loading-spinner";

export default {
  props: ["parentData"],
  name: "first-step",
  components: {
    StatusModal,
    BCard,
    colors,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TimePicker.name]: TimePicker,
    Modal,
    Circle8,
  },
  props: ["first-step"],
  data() {
    return {
      otheropen: false,
      quoopen: false,
      allfilename: [],
      allquodocname: [],
      disputedocid: 0,
      quotitle: "",
      modal: modal,
      positionid: "",
      marketingchannel: "",
      marketingchannels: [],
      cancelledref: "",
      cancelledrefs: [],
      uploadload: false,
      step: 0,
      jobno: "",
      servicelocation: "",
      arrivalETA: "18 Nov 2022",
      departureETD: "15 Nov 2022",
      companyName: "",
      companyAddress: "",
      phoneNoFaxNo: "",
      picFullName: "",
      picPhoneNoFaxNo: "",
      picEmail: "",
      previousPort: "None",
      nextPort: "None",
      lastPortAndDate: "None",
      reason: "",
      wastedetails: [
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
        },
      ],
      scroll: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },
      jobstatus: "",
      landvesselflag: "",
      modals: {
        disputereason: false,
        successModal: false,
        successUpload: false,
        removeModal: false,
        image: false,
        supportdoc: false,

      },
      message: "",
    };
  },
  created() {
    // this.jobstatus = this.$route.params.jobnum.split("_")[1];
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    console.log(this.positionid);
    this.jobno = this.$route.params.jobnum.split("_")[0];
    this.getMarketingChannel();
    this.getDetail(this.jobno);
    // this.getCancelRef(this.jobno);
  },
  mounted() { },

  methods: {
    openother() {
      console.log('okay ke?');

      this.otheropen = !this.otheropen;
    },
    openquo() {
      console.log('okay ke?');

      this.quoopen = !this.quoopen;
    },
    sendMarketingChannel() {
      let obj = {
        marketing_channel_id: this.marketingchannel,
      };

      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/accept", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
          }
        });
    },
    getMarketingChannel() {
      this.$http
        .get(":10001/api/v1/setting-private/marketing_channel")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              let obj = {
                value: response[i].marketing_channel_id,
                label: response[i].name,
              };
              this.marketingchannels.push(obj);
            }
            this.marketingchannel = this.marketingchannels[0].value;
          }
        });
    },
    openimage(url) {
      this.image = url;
      this.modals.image = true;
    },
    sendCancelledRef() {
      let obj = {
        reference_number: this.cancelledref,
      };

      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/accept ")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
          }
        });
    },
    getCancelRef(refno) {
      console.log(refno);

      this.$http
        .get(":10001/api/v1/incoming/" + refno + "/cancelled-ref")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.reference_number.length; i++) {
              let obj = {
                value: response.reference_number[i],
                label: response.reference_number[i],
              };
              this.cancelledrefs.push(obj);
            }
          }
        });
    },
    // saveDraft() {},
    onFileChange(event) {
      this.upload = true;
      const t = event.target;

      this.document = t.files.length;

      var input;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.file.files[i];
          const formData = new FormData();
          formData.append("document", input);

          this.quotitle = t.files[i].name;

          this.docs = formData;

          this.uploadload = true;
          this.buttondisabled = true;

          this.$http
            .post(
              ":10001/api/v1/incoming/" +
              this.jobno +
              "/upload/dispute-waste-job?mobile",
              this.docs,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: "Bearer " + sessionStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log("data masuk", response);

                this.modals.successUpload = true;
                // this.message = response
                // this.btnsubmit = false
                this.uploadload = false;

                this.disputedocid = response.document_id;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });

                this.uploadload = false;
              }
            });
          // this.uploadload = false;
          this.buttondisabled = false;
        }
      }
    },
    deletedisputedoc() {
      // this.disputedocid;
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" +
              this.jobno +
              "/upload/dispute-waste-job/" +
              this.disputedocid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.quotitle = "";

                this.modals.removeModal = true;
                setTimeout(() => {
                  // this.getSubmittedData();
                  // this.nextTab();
                }, 1000);
              }
            });
        }
      });
    },
    dispute() {
      if (this.reason != "") {
        let obj = {
          dispute_reason: this.reason,
        };
        this.$http
          .post(":10001/api/v1/incoming/" + this.jobno + "/dispute", obj)
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);

              // swal({
              //   title: `Success!`,
              //   text: response,
              //   buttonsStyling: false,
              //   confirmButtonClass: "btn btn-primary btn-fill",
              //   type: "success",
              // });

              this.modals.disputereason = false;
              this.exitTab();
            }
          });
      } else {
        // reason is compulsory
        swal({
          title: `Info!`,
          text: "Please fill in the reason",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "warning",
        });
      }
    },
    accept() {
      let obj = {
        marketing_channel_id: this.marketingchannel,
      };
      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/accept", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            this.getDetail(this.jobno)
            this.modals.disputereason = false;
            setTimeout(() => {
              this.nextTab();
            }, 1000);
          }
        });
    },
    getDetail(refNo) {
      this.wastedetails = [];
      this.allfilename = [];
      this.allquodocname = [];

      this.$http.get(":10001/api/v1/incoming/garbage/" + refNo).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          // this.landvesselflag = response.company.company_type.toUpperCase();
          if (typeof response.dashboard_step == 'string') {
            this.step = Number(response.dashboard_step)
          } else if (typeof response.dashboard_step == 'number') {
            this.step = response.dashboard_step;
          } else {
            this.step = response.dashboard_step;
          }

          this.servicelocation =
            response.service_location != null
              ? response.service_location.service_location
              : "-";

          this.companyName = response.company.company_name;
          this.companyAddress = response.company.company_address;

          this.phoneNoFaxNo =
            (response.company.company_phone_number == "" ||
              response.company.company_phone_number == null
              ? "N/A"
              : response.company.company_phone_number) +
            " / " +
            (response.company.company_fax_number == "" ||
              response.company.company_fax_number == null
              ? "N/A"
              : response.company.company_fax_number);
          this.picFullName = response.pic.pic_name;
          this.picPhoneNoFaxNo =
            (response.pic.pic_phone_number == "" ||
              response.pic.pic_phone_number == null
              ? "N/A"
              : response.pic.pic_phone_number) +
            " / " +
            (response.pic.pic_fax_number == "" ||
              response.pic.pic_fax_number == null
              ? "N/A"
              : response.pic.pic_fax_number);

          this.picEmail = response.pic.pic_email;

          for (var i = 0; i < response.waste_details.length; i++) {
            let obj = {
              no: i + 1,
              wastetype:
                response.waste_details[i].waste_type_name == ""
                  ? "N/A"
                  : response.waste_details[i].waste_type_name,
              packagingtype:
                response.waste_details[i].packaging_type_name == ""
                  ? "N/A"
                  : response.waste_details[i].packaging_type_name,
              wasteorigin: response.waste_details[i].waste_origin,
              wastecomponent: response.waste_details[i].waste_components,
              estqty: response.waste_details[i].estimated_quantity,
              estqtyunit: response.waste_details[i].estimated_quantity_unit,
              packagingqty: response.waste_details[i].packaging_quantity,
              packagingqtyunit: response.waste_details[i].packaging_type_name,
              remarks: response.waste_details[i].remark,
              image: response.waste_details[i].images,
            };

            this.wastedetails.push(obj);
          }

          if (response.waste_job_document != null) {
            for (var i = 0; i < response.waste_job_document.length; i++) {
              let obj = {
                filename: response.waste_job_document[i].meta.filename,
                fileid: response.waste_job_document[i].waste_job_document_id,
                fileurl: response.waste_job_document[i].url,
              };
              this.allfilename.push(obj);
            }


          }

          //get quo docs
          if (response.quotation != null)
            if (response.quotation.quotation_support_document != null) {
              for (var i = 0; i < response.quotation.quotation_support_document.length; i++) {
                let obj = {
                  filename: response.quotation.quotation_support_document[i].filename,
                  fileurl: response.quotation.quotation_support_document[i].url,
                  fileid: response.quotation.quotation_support_document[i].quotation_support_document_id,
                };
                this.allquodocname.push(obj);
              }
            }
        }
      });
    },
    nextTab() {
      let parameter = {
        step: "1",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    ptwTab() {
      let parameter = {
        step: "2",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    async exitTab() {
      let parameter = {
        step: "1",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    getScroll() {
      this.scroll = true;
    },
    getScroll2() {
      this.scroll = false;
    },
    onImageChange(file) {
      this.images.regular = file;

      this.img = file.name;

      const reader = new FileReader();

      reader.onload = (event) => {
        file = event.target.result;

        file.replace(event.target.result);

        this.imagebase64 = file.split(",")[1];
      };
      reader.readAsDataURL(file);
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
    },
  },
  watch: {
    // jobstatus() {
    //   if (this.jobstatus.toUpperCase() == "QUOTATION") {
    //     this.nextTab();
    //   }
    //   if (this.jobstatus.toUpperCase() == "PTW") {
    //     this.ptwTab();
    //   }
    // },
    step() {
      console.log(this.step);

      if (this.step == 1) {
        let parameter = {
          step: "0",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
      if (this.step == 2) {
        let parameter = {
          step: "1",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
      if (this.step == 3) {
        let parameter = {
          step: "2",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
      if (this.step == 4) {
        let parameter = {
          step: "3",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
      if (this.step == 5) {
        let parameter = {
          step: "4",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
      if (this.step == 6) {
        let parameter = {
          step: "5",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
    },
  },
};
</script>
<style scoped>
.textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

.textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out;
  background-color: 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.scrollable {
  height: 500px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}

.floating-buttons-container {
  position: relative;
  width: 100%;
  height: 100vh;
}

/* Styles for floating buttons */
.floating-buttons {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  width: 80px;
  z-index: 9999;
  left: 20px;
  /* Adjust as needed */
}

/* Styles for individual buttons */
.left-button,
.right-button {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #358CCB;
  /* You can change the color as desired */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
}

.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px;
  /* Adjust as needed */
}

.scrollable-content {
  flex: 0 0 auto;
  white-space: nowrap;
  margin-right: 15px;
  /* Adjust as needed */
}

.el-table .cell {
  word-break: break-word !important;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}
</style>
